import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconIcon24(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            className={customClassName}
            name="IconIcon24"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6 4.5h12q.202.001.389.05l-2.71 2.71A5.97 5.97 0 0 0 12 6c-1.386 0-2.663.47-3.68 1.26L5.612 4.55q.187-.049.389-.05m1.26 3.82L4.55 5.612q-.049.187-.05.389v12q.001.202.05.389l2.71-2.71A5.97 5.97 0 0 1 6 12c0-1.386.47-2.663 1.26-3.68m1.072 6.287A4.5 4.5 0 0 1 7.5 12c0-.972.308-1.872.832-2.607L10.939 12zM8.32 16.74l-2.71 2.71q.187.049.389.05h12q.202-.001.389-.05l-2.71-2.71A5.97 5.97 0 0 1 12 18a5.97 5.97 0 0 1-3.68-1.26m6.286-1.072A4.5 4.5 0 0 1 12 16.5a4.5 4.5 0 0 1-2.607-.832L12 13.061zm2.133.011 2.71 2.71q.049-.187.05-.389V6q-.001-.202-.05-.389l-2.71 2.71A5.97 5.97 0 0 1 18 12c0 1.386-.47 2.663-1.26 3.68m-1.072-6.286A4.5 4.5 0 0 1 16.5 12a4.5 4.5 0 0 1-.832 2.607L13.061 12zm-1.06-1.061L12 10.939 9.393 8.332A4.5 4.5 0 0 1 12 7.5a4.5 4.5 0 0 1 2.607.832M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconIcon24);
